/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-04 14:24:31
 */
export default {
  namespaced: true,
  state: {
    pending: 0,
    approved: 0,
    refuse: 0
  },
  mutations: {
    SET_PENDING (state, number) {
      state.pending = number
    },
    SET_APPROVED (state, number) {
      state.approved = number
    },
    SET_REFUSE (state, number) {
      state.refuse = number
    }
  },
  actions: {
    commitChangePending ({ commit }, number) {
      commit('SET_PENDING', number)
    },
    commitChangeApproved ({ commit }, number) {
      commit('SET_APPROVED', number)
    },
    commitChangeRefuse ({ commit }, number) {
      commit('SET_REFUSE', number)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/audit.js